import type { ReceiptTemplate } from '../schema';

export const swagbucksTemplate: ReceiptTemplate = {
  id: 'swagbucks',
  name: 'Swagbucks Receipt',
  brand: 'SWAGBUCKS',
  description: 'Swagbucks earnings receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: 'none',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'sb-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'SWAGBUCKS',
        businessNameFontSize: 18,
        addressLines: ['SB EARNED'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'sb-activity',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'activity', label: 'Activity:', value: 'Survey Complete' },
          { id: 'user', label: 'User:', value: 'JohnDoe' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'id', label: 'ID:', value: 'SB-847291034' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'sb-earnings',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'earned', label: 'SB EARNED', value: '150 SB', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'sb-balance',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'LIFETIME SB: 45,230\nAVAILABLE: 2,150 SB\n\nKEEP EARNING!', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

